import React from 'react';
import { Card, CardContent } from '../../components/ui/card';

export const StatsCards = ({ stats }) => {
  const formatNumber = (num, key) => {
    // For totalCustomers, format as "66.160 t"
    if (key === 'totalCustomers') {
      return new Intl.NumberFormat('de-DE', {
        maximumFractionDigits: 0
      }).format(num) + ' t';
    }
    // For CO₂ emissions cards, format with German thousands separators and no decimal places
    if (key === 'totalRevenue' || key === 'totalSales') {
      return new Intl.NumberFormat('de-DE', {
        minimumFractionDigits: 0,
        maximumFractionDigits: 0
      }).format(num) + ' t CO₂e';
    }
    return new Intl.NumberFormat('en-US').format(num);
  };

  const renderCard = (key, data) => {
    if (!data) return null;

    const isPositive = data.change > 0;
    let comparisonText;
    if (key === 'totalRevenue') {
      comparisonText = 'Referenzwert';
    } else if (key === 'totalCustomers') {
      comparisonText = 'Prognose';
    } else {
      comparisonText = 'Referenzjahr';
    }

    return (
      <Card className={key === 'totalRevenue' ? 'bg-green-50' : 'bg-blue-50'}>
        <CardContent className="pt-6">
          <div className={`text-sm ${key === 'totalSales' ? 'text-green-600' : 'text-gray-500'}`}>{data.label}</div>
          <div className={`text-3xl font-semibold mt-2 ${key === 'totalSales' ? 'text-green-600' : ''}`}>
            {formatNumber(data.value, key)}
          </div>
          {key === 'totalCustomers' ? (
            // Hide trend for Asphaltmischgut card
            <div className="text-sm mt-2 invisible">
              {/* Placeholder to maintain spacing */}
              &nbsp;
            </div>
          ) : key === 'totalRevenue' || key === 'totalSales' ? (
            // Hide trend for CO₂ cards - comment out the percentage comparison
            <div className="text-sm mt-2 invisible">
              {/* Placeholder to maintain spacing */}
              &nbsp;
            </div>
          ) : (
            <div className={`mt-2 ${isPositive ? 'text-red-500' : 'text-green-500'}`}>
              {isPositive ? '+' : ''}{data.change}% vs. {comparisonText}
            </div>
          )}
        </CardContent>
      </Card>
    );
  };

  return (
    <div className="grid grid-cols-3 gap-6 mb-4">
      {stats && Object.entries(stats).map(([key, data]) => (
        <div key={key}>{renderCard(key, data)}</div>
      ))}
    </div>
  );
};